<div class="inner-page-header">
  <div class="titles">
    <h3 class="title">الاسئلة / Q-{{ question?.id }}</h3>
  </div>
</div>

<div class="question-wrapper">
  <div class="actions">
    @if (!isQuestionClosed() && !isQuestionOpen()) {
      <button type="button" class="btn btn-green" (click)="acceptQuestion()">
        <img src="assets/images/svg/check-green.svg" alt="accept" />
        قبول السؤال
      </button>
    }
    @if (!isQuestionClosed()) {
      <button type="button" class="btn btn-delete" (click)="closeQuestion()">إغلاق السؤال</button>
    }
  </div>

  <div class="question-details">
    <div class="main-card">
      <h3 class="font-18 font-bold">السؤال</h3>

      <h4 class="font-16">تفاصيل السؤال</h4>
      <p class="font-bold">{{ question?.content }}</p>

      <h4 class="font-16">الصور</h4>
      @if (question?.attachments?.length) {
        @for (attachment of question?.attachments; track attachment.id) {
          <a [href]="attachment.file_url" target="_blank">
            <img [src]="attachment.file_url" [alt]="attachment.file_name" class="question-attachment" />
          </a>
        }
      } @else {
        <img src="assets/images/svg/building-placeholder.svg" alt="building-placeholder" />
      }

      <div class="form-group mt-3">
        <label for="" class="form-label"> التخصص </label>
        <ng-select bindLabel="name_ar" (scrollToEnd)="onScrollSpecializationsPagination()" #selectSpecializations
          placeholder="يرجى تحديد التخصص" appendTo="body" [(ngModel)]="selectedSpecialization" [searchable]="true"
          (removed)="resetSpecializationsSearch()" (search)="searchSpecializationsText()"
          (clear)="resetSpecializationsSearch()" (change)="onSpecializationChange($event)"
          (open)="resetSpecializationsSearch()" [virtualScroll]="true" [clearable]="true">
          @for (specialization of specializations; track specialization.id) {
          <ng-option [value]="specialization.id">
            {{specialization.name_ar}}
          </ng-option>
          }
        </ng-select>
      </div>
    </div>

    <div class="main-card">
      <div class="details-title">
        <h3 class="font-18 font-bold">معلومات السؤال</h3>
        <div class="status" [ngClass]="getStatusClass(question?.status)">{{ getStatusLabel(question?.status) }}</div>
      </div>
      <div class="details-wrapper">
        <div class="basic-data">
          <h4>اسم العميل</h4>
          <div class="double-tooltip">
            <p>
              <a [href]="'/pages/customers/customer-profile/' + question?.client?.id" target="_blank" class="client-name-link">
                {{ getClientName() }}
              </a>
              <span class="custom-tooltip">
                <img src="assets/images/svg/phone-tooltip.svg" alt="" />
                <span class="tooltip-text clickable" (click)="copyClientMobile()">
                  {{ question?.client?.mobile || '-' }}
                  <img src="assets/images/svg/copy-report-link.svg" alt="copy"
                    style="width: 14px; height: 14px; margin-left: 4px; cursor: pointer;" />
                </span>
              </span>
              <span class="custom-tooltip">
                <img src="assets/images/svg/email-tooltip.svg" alt="" />
                <span class="tooltip-text">{{ question?.client?.email || '-' }}</span>
              </span>
            </p>

          </div>
        </div>
        <div class="basic-data">
          <h4> تاريخ الإنشاء</h4>
          <p class="datetime"><bdi>{{ formatTime(question?.created_at) }}</bdi><bdi>{{ formatDate(question?.created_at) }}</bdi></p>
        </div>
        <div class="basic-data">
          <h4> تاريخ الإغلاق</h4>
          <p class="datetime"><bdi>{{ formatTime(question?.closed_at) }}</bdi><bdi>{{ formatDate(question?.closed_at) }}</bdi></p>
        </div>
        <div class="basic-data">
          <h4>التخصص</h4>
          <p>{{ question?.specialization?.name_ar || '-' }}</p>
        </div>
        <div class="basic-data">
          <h4> المجموعة</h4>
          <p>{{ question?.cohort?.name || '-' }}</p>
        </div>
        <div class="basic-data">
          <h4> رقم السؤال</h4>
          <p>Q-{{ question?.id }}</p>
        </div>
      </div>

      <h3 class="font-18 font-bold">فحوصات الذكاء الاصطناعي </h3>
      <div class="details-wrapper">
        <div class="basic-data">
          <h4>أمان الصورة</h4>
          <div class="status" [ngClass]="question?.attachments_safety ? 'status-green' : ''">{{ getSafetyLabel(question?.attachments_safety) }}</div>
        </div>
        <div class="basic-data">
          <h4>الصلة بالعقار (ثقة)</h4>
          <div class="status" [ngClass]="question?.relevance_safety ? 'status-open' : ''">{{ question?.relevance_safety ? question.relevance_safety + '%' : '-' }}</div>
        </div>
        <div class="basic-data">
          <h4>خلوّه من المعلومات الشخصية</h4>
          <div class="status" [ngClass]="question?.pii_safety ? 'status-green' : ''">{{ getSafetyLabel(question?.pii_safety) }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-change-log [questionId]="questionId"></app-change-log>

<app-answers-log [questionId]="questionId"></app-answers-log>
